import { costCentersApi } from "@/services/api/costCenters.api";
import appSnackbarService from "@/services/appSnackbar.service";
import i18n from "@/services/i18n";
import { fileDownloader } from "@/services/file-downloader.service";

interface CostCenterRequest {
  sortBy: string;
  descending: string;
  page: number;
  rowsPerPage: number;
  searchString: string[];
}

interface CostCenterPost {
  data: object;
  index: number;
}

interface CostCenterDelete {
  id: number;
  index: number;
}

export const costCentersState: any = {
  namespaced: false,
  state: {
    costCenters: [],
    totalItem: 0,
    total: 0,
    loading: true,
    fetching: false
  },
  mutations: {
    // load costCenters
    COST_CENTER_FETCH_SUCCESS(state: any, payload: any) {
      state.costCenters = payload.data;
      state.total = payload.data.length;
      state.totalItem = payload.totalCount;
      state.loading = false;
      state.fetching = false;
    },
    COST_CENTER_FETCH_START(state: any) {
      state.fetching = true;
    },
    COST_CENTER_FETCH_ERROR(state: any, payload: any) {
      state.fetching = false;
      state.error = payload;
    },

    // save
    COST_CENTER_SAVE_SUCCESS(state: any, payload: any) {
      if (payload.index > -1) {
        // update
        state.costCenters.splice(payload.index, 1, payload.data);
      } else {
        // add
        state.costCenters.push(payload.data);
      }
    },
    COST_CENTER_SAVE_START(state: any) {
      state.fetching = true;
    },
    COST_CENTER_SAVE_ERROR(state: any, payload: any) {
      state.fetching = false;
      state.error = payload;
    },

    // delete
    COST_CENTER_DELETE_SUCCESS(state: any, payload: any) {
      if (payload.index > -1) {
        state.costCenters.splice(payload.index, 1);
        state.loading = false;
      }
    },
    COST_CENTER_DELETE_START(state: any) {
      state.fetching = true;
      state.loading = true;
    },
    COST_CENTER_DELETE_ERROR(state: any, payload: any) {
      state.fetching = false;
      state.error = payload;
      state.loading = false;
    },
  },
  actions: {
    getCostCenters({ commit }: any, request: CostCenterRequest) {
      commit("COST_CENTER_FETCH_START");

      const promise = new Promise((resolve, reject) => {
        costCentersApi
          .getAll(request)
          .then(response => {
            commit("COST_CENTER_FETCH_SUCCESS", response.data);
            resolve(response);
          })
          .catch(error => {
            commit("COST_CENTER_FETCH_ERROR", error);
            reject(error);
          });
      });
      return promise;
    },
    saveCostCenter({ commit }: any, payload: CostCenterPost) {
      commit("COST_CENTER_SAVE_START");
      const editedIndex = payload.index;

      const promise = new Promise((resolve, reject) => {
        costCentersApi
          .save(payload.data)
          .then(response => {
            commit("COST_CENTER_SAVE_SUCCESS", {
              data: response.data,
              index: editedIndex
            });
            appSnackbarService.success(i18n.t("SUCCESS_MESSAGES.COST_CENTER_SAVED"));
            resolve(response);
          })
          .catch(error => {
            commit("COST_CENTER_SAVE_ERROR", error);
            reject(error);
          });
        });
      return promise;
    },
    deleteCostCenter({ commit }: any, payload: CostCenterDelete) {
      commit("COST_CENTER_DELETE_START");

      const deletedIndex = payload.index;
      costCentersApi
        .delete(payload.id)
        .then(response => {
          commit("COST_CENTER_DELETE_SUCCESS", {
            data: response.data,
            index: deletedIndex
          });
          appSnackbarService.warning(i18n.t("SUCCESS_MESSAGES.COST_CENTER_DELETED"));
        })
        .catch(error => {
          commit("COST_CENTER_DELETE_ERROR", error);
        });
    },
  }
};
